import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminVietos from './pages/AdminVietos';
import reportWebVitals from './reportWebVitals';
import { ivykis } from './utils/matavimas';

const isAdmin = window.location.search.includes('admin')

// Matavimas — vieną kartą per programėlės atidarymą (ne per React render'į,
// kad StrictMode dvigubas mount'as nedubliuotų įrašo).
if (!isAdmin) ivykis('atidare')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdmin ? <AdminVietos /> : <App />}
  </React.StrictMode>
);

// PWA service worker — registruojam tik produkcijoje
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {})
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
